export const ACCOUNTING_BILL_STATUS_REFUTE_HST = "refute_hst";
export const ACCOUNTING_BILL_STATUS_REFUTE_OTHER = "refute_other";
export const ACCOUNTING_BILL_STATUS_REFUTE_VENDOR = "refute_vendor";

export const ACCOUNTING_BILL_STATUS_UNALLOCATED = "unallocated";
export const ACCOUNTING_BILL_STATUS_ALLOCATED = "allocated";
export const ACCOUNTING_BILL_STATUS_SYNCED = "synced";
export const ACCOUNTING_BILL_STATUS_BATCHED = "batched";
export const ACCOUNTING_BILL_STATUS_PAID = "paid";

export const ACCOUNTING_BILL_STATUSES = [
    ACCOUNTING_BILL_STATUS_ALLOCATED,
    ACCOUNTING_BILL_STATUS_SYNCED,
    ACCOUNTING_BILL_STATUS_BATCHED,
    ACCOUNTING_BILL_STATUS_PAID,
    ACCOUNTING_BILL_STATUS_REFUTE_HST,
    ACCOUNTING_BILL_STATUS_REFUTE_OTHER,
];
